// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCjO9kLtKAH6lnXON596LM7Ke03CzEC8L0",
  authDomain: "realtor-clone-react-32c87.firebaseapp.com",
  projectId: "realtor-clone-react-32c87",
  storageBucket: "realtor-clone-react-32c87.appspot.com",
  messagingSenderId: "725778420622",
  appId: "1:725778420622:web:7e828fa5390e4657d44adf"
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();